import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import * as styles from "../components/index.module.css"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import {
  Box,
  Button,
  ButtonGroup,
  Container,
  SimpleGrid,
  GridItem,
  Flex,
  HStack,
  IconButton,
  useBreakpointValue,
  Input,
  InputGroup,
  InputRightElement,
  Heading,
  Card,
  CardBody,
  CardFooter,
  Stack,
  Text,
  Image
} from '@chakra-ui/react'
import { Link, navigate, useStaticQuery, graphql } from 'gatsby';
import { useQueryParamString } from 'react-use-query-param-string';

function IndexPage() {
  const [searchQuery, setSearchQuery, initialized] = useQueryParamString('q', '');
  const isDesktop = useBreakpointValue({ base: false, lg: true })
  
  function handleClick() {
    const params = new URLSearchParams({
      q: searchQuery
    });
    navigate(`/search?${params.toString()}`);
  }

  const data = useStaticQuery(graphql`
    query HeaderQuery {
      allWatch(limit: 20) {
        nodes {
          id
          make
          model
          price
          source {
            name
            url
          }
          image
        }
      }
    }
  `)

  const watches = data.allWatch.nodes;

  return (
    <Layout>
      <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Box style={{ textAlign: 'center', width: isDesktop ? '60%' : '100%' }}>
          <Heading _hover={{ color: 'primary'}} size="2xl">Watch Market Place</Heading>
          <Heading fontWeight="500" mt={5} size="lg">We automatically scan the internet looking for watches so you can find your grail watch faster</Heading>
          <ButtonGroup spacing={6}>
            <Link to="/brands"><Button _hover={{ backgroundColor: 'white', color: 'primary', borderColor: 'primary', borderStyle: 'solid', borderWidth: 1 }} backgroundColor="black" color="white" variant="solid" mt="10">View All Brands</Button></Link>
            <Link to="/watches"><Button _hover={{ backgroundColor: 'white', color: 'primary', borderColor: 'primary', borderStyle: 'solid', borderWidth: 1 }} backgroundColor="black" color="white" variant="solid" mt="10">View All Watches</Button></Link>
          </ButtonGroup>
          <InputGroup size='md' mt={10}>
              <Input
                  pr='4.5rem'
                  type="text"
                  placeholder='Search'
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
              />
              <InputRightElement width='4.5rem' mr={2}>
                  <Button variant="solid" h='1.75rem' size='sm' onClick={handleClick}>
                      Search
                  </Button>
              </InputRightElement>
          </InputGroup>
        </Box>
      </Box>
      <Heading textAlign="center" mt="20" size="lg">Recent Watches</Heading>
      <SimpleGrid columns={{lg: 4, sm: 12 }} spacing={4} style={{ width: '100%'}} className="my-10">
        { watches.map(watch => {
          return (
            <GridItem>
              <Card maxW='sm' h="100%">
                <CardBody>
                  <Image src={watch.image} alt={watch.model} />
                  <Stack mt='6' spacing='3'>
                    <Heading size="md">{ watch.model }</Heading>
                    <Heading size="sm">{ watch.make }</Heading>
                    <Text>{ watch.source.name }</Text>
                    <Text>{ watch.price }</Text>
                  </Stack>
                </CardBody>
                <CardFooter>
                  <Link style={{ width: '100%'}} to={`/watch/${watch.id}`}>
                    <Button _hover={{ backgroundColor: 'primary', color: 'white' }} backgroundColor="black" color="white" style={{ width: '100%', marginTop: 10, marginLeft: 5, marginRight: 5, marginTop: 'auto'}}>View</Button>
                  </Link>
                </CardFooter>
              </Card>
            </GridItem>
          )
        })}
      </SimpleGrid>
    </Layout>
  )
}


/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo title="Home" />

export default IndexPage